<template id="">
    <div id="step-0" class="d-flex flex-column h-100 justify-content-between align-items-center w-100 ">
        <span></span>
        <h1 class="text-white mb-0 display-1 text-uppercase">Find the right hybrid<br>for your farm</h1>

        <div class="d-flex w-100 justify-content-center mt-auto_">
            <a v-on:click.prevent="updateValue(start)" class="btn btn-primary btn-lg mt-md-4" href="#">Get Started</a>
        </div>

    </div>
</template>
<script>
export default {
    data() {
        return {
            start: {
                id: 'start',
                name: 'Get Started',
                value: true,
            }
        }
    },

    props: ['value', 'formSummary'],

    computed: {

    },

    methods: {
        updateValue(option) {
            this.$emit('input', option);
        }
    },
}
</script>
